import { render } from "./BaseSpinner.vue?vue&type=template&id=2b39a748&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=2b39a748&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39a748"]])

export default __exports__